import detectIt from 'detect-it';
import loadSvgSprite from './svg-sprite-loader';
import { develop } from './develop';

const DEBUG_HOSTS = /localhost|flashback/ig;

let scrollTimerId;

/**
 * General page helper methods and utilities
 */

class Helper {
  init() {
    loadSvgSprite();

    this.initScrollPerformance();

    if (detectIt.deviceType !== 'mouseOnly') {
      document.documentElement.classList.remove('no-touch');
      document.documentElement.classList.add('touch');
    }

    if (
      window.location &&
      window.location.host &&
      window.location.host.match(DEBUG_HOSTS) !== null
    ) {
      develop.init();
    }
  }

  initScrollPerformance() {
    window.addEventListener(
      'scroll',
      this.onScroll.bind(this),
      detectIt.passiveEvents ? { capture: false, passive: true } : false
    );
  }

  onScroll() {
    window.clearTimeout(scrollTimerId);
    if (document.body.querySelector('main').classList.contains('no-hover') === false) {
      this.disableHover();
    }

    scrollTimerId = setTimeout(() => {
      this.enableHover();
    }, 500);
  }

  disableHover() {
    document.body.querySelector('main').classList.add('no-hover');
  }

  enableHover() {
    document.body.querySelector('main').classList.remove('no-hover');
  }
}

export const helper = new Helper();



// WEBPACK FOOTER //
// ./src/js/utils/helper.js